import { render, staticRenderFns } from "./LoaderDialog.vue?vue&type=template&id=38e6b810&scoped=true&"
import script from "./LoaderDialog.vue?vue&type=script&lang=js&"
export * from "./LoaderDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoaderDialog.vue?vue&type=style&index=0&id=38e6b810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6b810",
  null
  
)

export default component.exports